/**
 * Story arc id → human-readable German title.
 *
 * Mirrored from curriculum/story_arcs.py at the time of the Phase-2 branding
 * strip (2026-04-26). When a new arc lands in the backend, add it here too —
 * fallback returns "Lernabenteuer" for unknown ids so the TopBar never breaks.
 */
const ARC_TITLES: Record<string, string> = {
  schatzsuche:         'Die große Schatzsuche',
  zaubermarkt:         'Der große Zaubermarkt',
  drachenhoehle:       'Die Drachenhöhle',
  weiser_affe:         'Der weise Affe und die Fischer',
  grosszuegiger_loewe: 'Der großzügige Löwe',
  kluge_kraehe:        'Die kluge Krähe',
  mutige_schildkroete: 'Die mutige Schildkröte',
  listiger_schakal:    'Der listige Schakal',
};

export function arcTitle(arcId?: string | null): string {
  if (!arcId) return 'Lernabenteuer';
  return ARC_TITLES[arcId] || 'Lernabenteuer';
}
